module.exports = __webpack_public_path__ + "img/5.ff6e0a4e.png";